import { isWhatuni } from "@packages/lib/utlils/commonFunction";

let redirectSignInUrl: string;

switch (process.env.NEXT_PUBLIC_ENVIRONMENT) {
  case "dev":
    redirectSignInUrl = isWhatuni() ? "https://mdev.dev.aws.whatuni.com/authverification" :"https://mdev.dev.aws.postgraduatesearch.com/authverification" ;
    break;
  case "stg":
    redirectSignInUrl = isWhatuni() ? "https://mtest.test.aws.whatuni.com/authverification":"https://mtest.test.aws.postgraduatesearch.com/authverification";
    break;
  case "prd":
    redirectSignInUrl =isWhatuni() ? "https://www.whatuni.com/authverification":"https://www.postgraduatesearch.com/authverification";
    break;
  default:
    redirectSignInUrl = isWhatuni() ? "http://localhost:3000/authverification" : "http://localhost:3001/authverification";
}

const awsconfig: any = {
  Auth: {
    Cognito: {
      userPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOLS_ID,
      userPoolClientId: isWhatuni() ? process.env.NEXT_PUBLIC_AWS_USER_POOLS_WEB_CLIENT_ID : process.env.NEXT_PUBLIC_AWS_USER_POOLS_WEB_CLIENT_ID_PGS,
      loginWith: {
        // OPTIONAL - Hosted UI configuration
        oauth: {
          domain: process.env.NEXT_PUBLIC_COGNITO_OAUTH_DOMAIN,
          scopes: [
            //'phone',
            "email",
            "profile",
            "openid",
            //'aws.cognito.signin.user.admin'
          ],

          redirectSignIn: [redirectSignInUrl],
          redirectSignOut: [],

          responseType: "code", // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};


export default awsconfig;
